export default __webpack_public_path__ + "locales/ru/ConnectDialog.json?hash=f37e7094e6cc7d5394c2f84e915d36c0";